export default {
  subtitle: 'Vi sender de valgte hændelser som POST til dine endpoints, signeret med endpointets hemmelighed.',
  regenerate_confirm:
    'Generere en ny signeringshemmelighed? Den nuværende hemmelighed holder op med at virke med det samme.',
  delete_confirm: 'Slette dette endpoint? Det modtager ikke længere hændelser.',
  consecutive_failures: '{{count}} fejl i træk',
  columns: {
    url: 'Endpoint',
    events: 'Hændelser',
    status: 'Status',
    secret: 'Hemmelighed',
  },
  statuses: {
    active: 'Aktiv',
    disabled: 'Deaktiveret',
    auto_disabled: 'Automatisk deaktiveret',
  },
  buttons: {
    create: 'Tilføj endpoint',
    edit: 'Rediger',
    regenerate_secret: 'Ny hemmelighed',
    delete: 'Slet',
  },
  toasts: {
    load_error: 'Webhook-endpoints kunne ikke indlæses.',
    error: 'Noget gik galt. Prøv igen.',
    deleted: 'Endpoint slettet.',
  },
};
